import { cn } from '@/utils'
import { NodeEditMoveIcon, PenPlusMinus } from '@/components/app/editor/tools/shapes-tool'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

interface ModeToggleButtonProps {
  isPenEditMode: boolean
  onSelectMode: () => void
  onPenMode: () => void
  isHovered: boolean
  onHoverStart: () => void
  onHoverEnd: () => void
  tooltipContainer: HTMLElement | null
}

/** Toggles node editing between Select/Move and Pen (add/remove nodes). */
export function ModeToggleButton({
  isPenEditMode,
  onSelectMode,
  onPenMode,
  isHovered,
  onHoverStart,
  onHoverEnd,
  tooltipContainer,
}: ModeToggleButtonProps) {
  return (
    <Tooltip open={isHovered}>
      <TooltipTrigger asChild>
        <button
          onClick={isPenEditMode ? onSelectMode : onPenMode}
          onPointerEnter={onHoverStart}
          onPointerLeave={onHoverEnd}
          className={cn(
            'flex h-9 w-9 flex-shrink-0 cursor-pointer items-center justify-center rounded-lg border-none p-0 text-[#1a1a1a] transition-colors',
            !isPenEditMode ? 'bg-black/[0.08]' : 'bg-transparent hover:bg-black/[0.06]'
          )}
        >
          {isPenEditMode ? (
            <PenPlusMinus className="h-4 w-4" />
          ) : (
            <NodeEditMoveIcon className="h-4 w-4" />
          )}
        </button>
      </TooltipTrigger>
      <TooltipContent side="top" container={tooltipContainer}>
        {isPenEditMode
          ? 'Add and remove  — Click for Move'
          : 'Select and move  — Click for Add/Remove'}
      </TooltipContent>
    </Tooltip>
  )
}
